module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"title":"Собеседование","tag":"Видеособеседование","next":"Далее"}}')
  delete Component.options._Ctor
}
